import React, { useState, useEffect } from "react";
import { Roller } from "react-awesome-spinners";
import MyNavbar from "../component/navbar";
import Navbarinner from "../component/navbarinner";
import { Col, Container, Row, Button, Form, InputGroup } from "react-bootstrap";
import MyFooter from "../component/footer";
import isEmpty from "is-empty";
import { toastAlert } from "../helper/toastAlert";
import { kycReq, getKycInfo } from "../ApiAction/api";
import { kycValidate, kycInputValidate } from "../validation/validation";
import config from "../config/config";
import { Link } from "react-router-dom";

export default function KYCPage(props) {
  const [formData, setFormData] = useState({
    idType: "",
    frontImage: null,
    backImage: null,
    walletAddress: "",
    agreeTerms: false,
    status: "",
    reason: "",
    _id: null,
  });

  const [errors, setErrors] = useState({});
  const [loader, setloader] = useState(false);
  const [fetching, setfetching] = useState(false);
  const [frontPreview, setFrontPreview] = useState(null);
  const [backPreview, setBackPreview] = useState(null);

  useEffect(() => {
    getData();
  }, [localStorage.getItem("WinChoToken")]);

  async function getData() {
    setfetching(true);
    try {
      let { data, status } = await getKycInfo();
      console.log(data, status, "898989989889921");
      if (data && data._id && status) {
        var kyvstatus = "";
        if (data?.status == "pending") {
          kyvstatus = "Processing";
        }
        if (data?.status == "approved") {
          kyvstatus = "Verified";
        } else if (data?.status == "rejected") {
          kyvstatus = "Rejected";
        }

        setFormData({
          idType: data?.idType,
          frontImage: { name: data?.frontImage },
          backImage: { name: data?.backImage },
          walletAddress: data?.walletAddress,
          agreeTerms: data?.agreeTerms,
          status: kyvstatus,
          reason: data?.reason,
          _id: data?._id,
        });
        setFrontPreview(`${config.imageUrl}/kyc/${data?.frontImage}`);
        setBackPreview(`${config.imageUrl}/kyc/${data?.backImage}`);
      }
      setfetching(false);
    } catch (err) {
      setfetching(false);
    }
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    let validateErr = kycInputValidate(value, name);
    delete errors[name];
    let err = { ...errors, ...validateErr };
    setErrors(err);
  };

  const handleImageChange = (e, side) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ["image/jpeg", "image/jpg", "image/png"];
    const maxSize = 5 * 1024 * 1024;

    if (!validTypes.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        [`${side}Image`]: "Only JPG, JPEG, PNG files are allowed",
      }));
      return;
    }

    if (file.size > maxSize) {
      setErrors((prev) => ({
        ...prev,
        [`${side}Image`]: "File size must be less than 5 MB",
      }));
      return;
    }

    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[`${side}Image`];
      return newErrors;
    });

    const reader = new FileReader();
    reader.onloadend = () => {
      if (side === "front") {
        setFrontPreview(reader.result);
      } else {
        setBackPreview(reader.result);
      }
    };
    reader.readAsDataURL(file);
    setFormData((prev) => ({
      ...prev,
      [`${side}Image`]: file,
    }));
  };

  const removeImage = (side) => {
    if (side === "front") {
      setFrontPreview(null);
      setFormData((prev) => ({ ...prev, frontImage: null }));
    } else {
      setBackPreview(null);
      setFormData((prev) => ({ ...prev, backImage: null }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    let errors = kycValidate(formData);
    if (!isEmpty(errors)) {
      setErrors(errors);
      return;
    }

    setloader(true);
    try {
      const { status, message } = await kycReq(formData);
      if (status) {
        getData();
        toastAlert(
          "success",
          "Your KYC request has been submitted successfully. Please wait, we update the status shortly.",
          "kycval"
        );
      } else {
        toastAlert(
          "error",
          message,
          "kycval"
        );
      }
    } catch (error) {
      console.error("Error loader KYC:", error);
      setErrors((prev) => ({
        ...prev,
        submit: "Failed to submit KYC. Please try again.",
      }));
      toastAlert("error", "Failed to submit KYC. Please try again.", "kycval");
    } finally {
      setloader(false);
    }
  };

  return (
    <>
      <Navbarinner />

      <section className="referral_page kyc_page">
        {fetching ? (
          <div className="text-center">
            <Roller className="loading mx-auto" color="white" />
          </div>
        ) : (
          <Container>
            <Row className="justify-content-center">
              <Col lg="6" md="12">
                <div className="back_btn">
                  <h1 className="join_head ">KYC</h1>
                  <Link to="/dashboard" className="">
                    <img
                      src={require("../assets/images/back_icon.png")}
                      alt=""
                      className="img-fluid"
                    />{" "}
                    Back
                  </Link>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col lg="6" md="12">
                <div className="reg_form referral_page_head">
                  <Form onSubmit={handleSubmit}>
                    <div>
                      <Form.Label className="input_join" htmlFor="idType">
                        Select ID Type
                      </Form.Label>
                      <Form.Select
                        name="idType"
                        value={formData.idType}
                        onChange={handleChange}
                        className="input_select"
                        isInvalid={!!errors.idType}
                      >
                        <option value="">Select ID Type</option>
                        <option value="1">Aadhar Card</option>
                        <option value="2">Pan Card</option>
                        <option value="3">Voter ID</option>
                      </Form.Select>
                      {errors.idType && (
                        <Form.Control.Feedback type="invalid">
                          {errors.idType}
                        </Form.Control.Feedback>
                      )}
                      <p>
                        The document you are providing must be valid at least 30
                        days and contain all of the following details:
                      </p>
                      <div>
                        <Form.Label className="input_join">
                          Upload Your ID
                        </Form.Label>
                        <p>

                        </p>

                        <Form.Label className="input_join">
                          Front Side (Provide files in JPEG, JPG, PNG format, 5 MB maximum)
                        </Form.Label>
                        <div className="ignore-container">
                          <div className="file-upload">
                            <div className="file-wrap">
                              <input
                                type="file"
                                name="upload"
                                id="frontUpload"
                                accept="image/jpeg, image/jpg, image/png"
                                onChange={(e) => handleImageChange(e, "front")}
                                disabled={
                                  formData.status == "Processing" ||
                                  formData.status == "Verified"
                                }
                              />
                              <div className="custom-upload-design">
                                <div className="upload-text">
                                  Upload front Side
                                </div>
                              </div>
                            </div>
                            {frontPreview && (
                              <div className="upload_img">
                                <div className="d-flex align-items-center gap-3">
                                  <img
                                    src={frontPreview}
                                    alt="Front ID Preview"
                                    style={{
                                      maxWidth: "50px",
                                    }}
                                  />
                                  <p className="mb-0">
                                    {formData.frontImage.name}
                                  </p>
                                </div>
                                {(!formData.status ||
                                  formData.status == "Rejected") && (
                                    <img
                                      src={require("../assets/images/close_icon.png")}
                                      alt="Remove"
                                      className="img-fluid"
                                      onClick={() => removeImage("front")}
                                      style={{ cursor: "pointer" }}
                                    />
                                  )}
                              </div>
                            )}
                          </div>
                          {errors.frontImage && (
                            <div className="text-danger small">
                              {errors.frontImage}
                            </div>
                          )}
                        </div>

                        {formData.idType !== "2" && (
                          <>
                            <Form.Label className="input_join">
                              Back Side (Provide files in JPEG, JPG, PNG format, 5 MB maximum)
                            </Form.Label>
                            <div className="ignore-container">
                              <div className="file-upload">
                                <div className="file-wrap">
                                  <input
                                    type="file"
                                    name="upload"
                                    id="backUpload"
                                    accept="image/jpeg, image/jpg, image/png"
                                    onChange={(e) =>
                                      handleImageChange(e, "back")
                                    }
                                    disabled={
                                      formData.status == "Processing" ||
                                      formData.status == "Verified"
                                    }
                                  />
                                  <div className="custom-upload-design">
                                    <div className="upload-text">
                                      Upload back Side
                                    </div>
                                  </div>
                                </div>

                                {backPreview && (
                                  <div className="upload_img">
                                    <div className="d-flex align-items-center gap-3">
                                      <img
                                        src={backPreview}
                                        alt="Back ID Preview"
                                        style={{
                                          maxWidth: "50px",
                                        }}
                                      />
                                      <p className="mb-0">
                                        {formData.backImage.name}
                                      </p>
                                    </div>

                                    {(!formData.status ||
                                      formData.status == "Rejected") && (
                                        <img
                                          src={require("../assets/images/close_icon.png")}
                                          alt="Remove"
                                          className="img-fluid"
                                          onClick={() => removeImage("back")}
                                          style={{ cursor: "pointer" }}
                                        />
                                      )}
                                  </div>
                                )}
                              </div>
                              {errors.backImage && (
                                <div className="text-danger small">
                                  {errors.backImage}
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>

                      <Form.Label
                        className="input_join"
                        htmlFor="walletAddress"
                      >
                        Wallet Address
                      </Form.Label>
                      <InputGroup className="input_group_box mb-4">
                        <Form.Control
                          name="walletAddress"
                          value={formData.walletAddress}
                          onChange={handleChange}
                          placeholder="0x..."
                          isInvalid={!!errors.walletAddress}
                        />
                        {errors.walletAddress && (
                          <Form.Control.Feedback type="invalid">
                            {errors.walletAddress}
                          </Form.Control.Feedback>
                        )}
                      </InputGroup>

                      {formData.reason && <Form.Label
                        className="input_join"
                        htmlFor="walletAddress"
                      >
                        Kyc rejection reason
                      </Form.Label>}
                      {formData.reason && <InputGroup className="input_group_box mb-4">
                        <Form.Control
                          name=""
                          value={formData.reason}
                          as="textarea"
                          rows={3}
                          readOnly
                        />
                        {errors.walletAddress && (
                          <Form.Control.Feedback type="invalid">
                            {errors.walletAddress}
                          </Form.Control.Feedback>
                        )}
                      </InputGroup>}

                      <Form.Check className="mb-4">
                        <Form.Check.Input
                          type="checkbox"
                          id="agreeTerms"
                          name="agreeTerms"
                          checked={formData.agreeTerms}
                          onChange={handleChange}
                          isInvalid={!!errors.agreeTerms}
                        />
                        <Form.Check.Label htmlFor="agreeTerms">
                          I have read and agree to the
                          <a href="/terms"> terms and conditions</a>,
                          <a href="/privacy"> privacy policy</a>
                        </Form.Check.Label>
                        {errors.agreeTerms && (
                          <div className="text-danger small">
                            {errors.agreeTerms}
                          </div>
                        )}
                      </Form.Check>

                      {formData.status && (
                        <div>
                          <Form.Label className="input_join">
                            Kyc Status
                          </Form.Label>
                          <h5 className={formData.status == "Verified" || formData.status == "Processing" ? "text_green" : "text_red"}>{formData.status}</h5>
                        </div>
                      )}

                      <Button
                        type="submit"
                        className="primary_btn w-100"
                        disabled={
                          loader ||
                          formData.status == "Processing" ||
                          formData.status == "Verified"
                        }
                      >
                        Submit KYC {loader && <i className="fas fa-spinner fa-spin"></i>}
                      </Button>
                    </div>
                  </Form>
                </div>
              </Col>
            </Row>
          </Container>
        )}
      </section>
      <MyFooter />
    </>
  );
}
